// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CardRemoveIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CardRemove/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.75 12.525a3.332 3.332 0 0 0-3.333 3.333 3.332 3.332 0 1 0 6.666 0 3.332 3.332 0 0 0-3.333-3.333Zm1.333 4.708a.618.618 0 0 1-.441.184.618.618 0 0 1-.442-.184l-.442-.441-.458.458a.618.618 0 0 1-.442.183.618.618 0 0 1-.441-.183.629.629 0 0 1 0-.883l.458-.459-.442-.441a.629.629 0 0 1 0-.884.629.629 0 0 1 .884 0l.441.442.417-.417a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .884l-.416.416.441.442a.629.629 0 0 1 0 .883ZM18.333 6.292v.375a.836.836 0 0 1-.833.833h-15a.836.836 0 0 1-.833-.833v-.384a3.446 3.446 0 0 1 3.45-3.45h9.758a3.46 3.46 0 0 1 3.458 3.459Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.667 9.583v4.134a3.446 3.446 0 0 0 3.45 3.45h5.216c.484 0 .9-.409.859-.892-.117-1.275.291-2.658 1.425-3.758a4.23 4.23 0 0 1 1.666-1.009 4.664 4.664 0 0 1 2.942.009.834.834 0 0 0 1.108-.784V9.575a.836.836 0 0 0-.833-.833h-15a.848.848 0 0 0-.833.841Zm5 4.792H5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h1.667a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Z"
}));
export default CardRemoveIcon;